import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal } from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../../../redux/api";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import {
  getCategary,
  getIndustry,
  getLanguage,
  getPenalty,
  getSkills,
} from "../../../../redux/categary/action";
import { getPostsById } from "../../../../redux/posts/action";
import ModalTitle from "../UpdateModels/ModalTitle";
import ModelCategory from "../UpdateModels/ModelCategory";
import ModelSubCategory from "../UpdateModels/ModelSubCategory";
import ModalDescription from "../UpdateModels/ModalDescription";
import ModelDuretion from "../UpdateModels/ModelDuretion";
import ModelBudget from "../UpdateModels/ModelBudget";
import ModelLanguage from "../UpdateModels/ModelLanguage";
import ModelDeliverables from "../UpdateModels/ModelDeliverables";
import ModelFile from "../UpdateModels/ModelFile";
import ModelSkills from "../UpdateModels/ModelSkills";
import ModelMilestones from "../UpdateModels/ModelMilestones";
import ModelType from "../UpdateModels/ModelType";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { Tooltip } from "react-tooltip";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import { addpresent } from "../../../Common/FewCommonMethods";
import { formatNumberWithCommas } from "../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import ModalIndustry from "../UpdateModels/ModalIndustry";
import { descriptionvalidation, titlevalidation } from "../../../Common/commonvalidation";
import { isDurationLessThanMilestones } from "../../../../utils/isDurationLessThanMilestones";
import { isPriceWithinBudget } from "../../../../utils/isPriceWithinBudget";
import MilestonesDisplay from "../../../Common/MilestonesDisplay";
import { penaltytips } from "../../../Common/Tooltips/tooltip";
import { decodeHtml } from "../../../../assests/extention/commonfunction";
const UpdateProject = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    title: "",
    price: "",
    // type: '',
    is_ambrella: "0",
    ambrella_title: "",
    industry_id: "",
    industry_index: "",
    parent_id: "0",
    category_id: "0",
    sub_category_id: "0",
    description: "",
    duration_type: "0",
    duration: "0",
    deliverables: "",
    language_id: "0",
    last_date: "",
    hiring_type: "0",
    work_location: "0",
    country_id: "0",
    city_name: "",
    skills: [],
    milestones: "",
    amount: "",
    penalty: "",
    files: [],
    languageindex: "",
  });

  useEffect(() => {
    if (posts) {
      setFormData({
        id: posts.id,
        title: posts.title,
        price: posts.price,
        // type: posts.type,
        is_ambrella: posts.is_ambrella,
        ambrella_title: posts.ambrella_title,
        parent_id: posts.parent_id,
        industry_id: posts.industry_id,
        category_id: posts.category_id,
        sub_category_id: posts.sub_category_id,
        description: posts.description,
        duration_type: posts.duration_type,
        duration: posts.duration,
        deliverables: posts.deliverables,
        language_id: posts.language_id,
        last_date: posts.last_date,
        hiring_type: posts.hiring_type,
        work_location: posts.work_location,
        country_id: posts.country_id,
        city_name: posts.city_name,
        skills: posts.skills,
        milestones: posts.milestones,
        amount: posts.amount,
        penalty: posts.penalty,
        files: posts?.files,
        languageindex: posts.language_title,
      });
      setTitle(posts.title);
      setDescription(posts.description);
      setProjectbudget(posts.price);
      setExpecteddeliverables(posts.deliverables);
    }
  }, [posts, location]);

  const [modaltitle, setModaltitle] = useState(false);
  const [title, setTitle] = useState(formData.title);
  const [modalcategory, setModalCategory] = useState(false);
  const [industryEditModal, setIndustryEditModal] = useState(false);
  const [Theindustry, setIndustry] = useState(formData.industry_index);
  const [category, setCategory] = useState(formData.category_index);
  const [subcategory, setSubCategory] = useState(formData.category_index);
  const [modalsubcategory, setModalSubCategory] = useState(false);
  const [modaldescription, setModalDescription] = useState(false);
  const [description, setDescription] = useState(formData.description);
  const [modalduretion, setModalduretion] = useState(false);
  const [duration, setProjectduration] = useState(formData.duration);
  const [modalBudget, setModalBudget] = useState(false);
  const [price, setProjectbudget] = useState(formData.price);
  const [modalLanguage, setModalLanguege] = useState(false);
  const [language_id, setLanguege] = useState(formData.language_id);
  const [modaldeliverables, setModaldeliverables] = useState(false);
  const [deliverables, setExpecteddeliverables] = useState(
    formData.deliverables
  );
  const [modalfile, setModalFile] = useState(false);
  const [modalSkills, setModalSkills] = useState(false);
  const [modalMils, setModalMils] = useState(false);
  const [modaltype, setModaltype] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  useEffect(() => {
    dispatch(getCategary());
    dispatch(getSkills());
    dispatch(getLanguage());
    dispatch(getPenalty());
    dispatch(getIndustry());
    LoadCSSforfirstTime("Assets/scss/postproject.module.scss");
  }, []);

  const TheIndustryList = useSelector(
    ({ categary: { industrylist } }) => industrylist
  );

  const industry_index = Array.isArray(TheIndustryList) && TheIndustryList?.length != 0 && Array.isArray(TheIndustryList) && TheIndustryList?.find(
    (item) => item.id === formData.industry_id
  );

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id, location]);

  const categarylist = useSelector(
    ({ categary: { categarylist } }) => categarylist
  );
  const category_index = categarylist.find(
    (item) => item.id === formData.category_id
  );

  useEffect(() => {
    industry_index && setIndustry(industry_index);
  }, [industry_index]);

  useEffect(() => {
    setCategory(category_index);
  }, [category_index]);

  useEffect(() => {
    axiosInstance
      .get(`category?type=3&parent_id=${formData.category_id}`)
      .then((response) => {
        const subcategarylist = response?.data?.response;
        const subcategory_index =
          Array.isArray(subcategarylist) &&
          subcategarylist.find((item) => item.id == formData.sub_category_id);
        setSubCategory(subcategory_index);
      });
  }, [formData?.category_id, formData.sub_category_id]);

  const hitApi = () => {
    const data = {
      ...formData,
      title: title,
      description: description,
      price: price,
      deliverables: deliverables,
    };
    setFormData(data);
  };

  const handleSubmit = async (values, formikHelpers) => {
    const isDurationValid = isDurationLessThanMilestones(
      values.duration,
      values.duration_type,
      values.milestones
    );

    const isBudgetValid = isPriceWithinBudget(values.price, values.milestones);

    if (!isDurationValid || !isBudgetValid) {
      formikHelpers.setErrors({
        duration: !isDurationValid
          ? "Total milestone duration cannot exceed total project duration."
          : undefined,
        price: !isBudgetValid
          ? "Total milestone amounts cannot exceed project budget."
          : undefined,
      });
      return;
    }
    setLoading(true); // start loader

    axiosInstance
      .put("post/update", formData)
      .then((response) => {
        if (response?.data?.status) {
          navigate(-1);
        }
        urtoast(response?.data?.response.message, 1);
      })
      .catch((error) => {
        urtoast(error.message, 2);
      })
      .finally(() => {
        setLoading(false); // stop loader
      });
  };


  const validationSchema = Yup.object().shape({
    // type: Yup.string().required('This is required'),
    title: titlevalidation,
    category_id: Yup.string().required("This is required"),
    // sub_category_id: Yup.string().required('This is required'),
    description: descriptionvalidation,
    skills: Yup.array().required("This is required"),
    price: Yup.string().required("This is required"),
    duration: Yup.string().required("Duration Type is required"),
    duration_type: Yup.string().required("Duration is required"),
    // files: Yup.array().min(1, 'At least one file is required').required('This is required'),
    deliverables: Yup.string().required("This is required"),
    language_id: Yup.string().required("This is required"),
  });

  const handleInputTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleInputDescription = (e) => {
    setDescription(e.target.value);
  };
  const handleInputDuretion = (e) => {
    setProjectduration(e.target.value);
  };
  const handleInputBudget = (e) => {
    setProjectbudget(e.target.value);
  };
  const handleInputExpecteddeliverables = (e) => {
    setExpecteddeliverables(e.target.value);
  };

  return (
    <div className="bg-project">
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              <div className="col-lg-10   mx-auto project-det">
                <div className="project-first">
                  <h4>Project Details</h4>
                  <button
                    type="submit"
                    onClick={formik.handleSubmit}
                    disabled={loading}
                    className={loading ? "loading-button background-button buttons" : "background-button buttons"}
                  >
                    {loading ? (
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    ) : (
                      <>
                        Post Project
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                          alt=""
                        />
                      </>
                    )}
                  </button>

                </div>
                <div className="project-row">
                  <div className="project-section">
                    <div>
                      <p>Project Title</p>
                      <h4>{formData.title}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModaltitle(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="error"
                  />
                  <div className="project-section">
                    <div>
                      <p>Industry</p>
                      <h4>{Theindustry?.title}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setIndustryEditModal(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="category_id"
                    component="div"
                    className="error"
                  />
                  <div className="project-section">
                    <div>
                      <p>Category</p>
                      <h4>{category?.title}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Subcategory</p>
                      <h4>{subcategory?.title}</h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalSubCategory(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="sub_category_id"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Description</p>
                      <CustomReactQuillDescription
                        value={formData?.description}
                      />
                    </div>
                    <span
                      onClick={() => {
                        setModalDescription(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="description"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Competencies</p>
                      <div
                        className="d-flex"
                        style={{ gap: "10px", flexWrap: "wrap" }}
                      >
                        {formData.skills &&
                          Array.isArray(formData.skills) &&
                          formData.skills.map((item, index) => {
                            return <h4 key={index}> {decodeHtml(item.title)}, </h4>;
                          })}
                      </div>
                    </div>
                    <span
                      onClick={() => {
                        setModalSkills(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="skills"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Budget</p>
                      <h4>
                        {formData?.price && "$ "}
                        {formatNumberWithCommas(formData?.price)}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalBudget(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="price"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Deadline</p>
                      <h4>
                        {formData?.duration} &nbsp;
                        {formData?.duration_type == 1
                          ? "Hour"
                          : formData?.duration_type == 2
                            ? "Days"
                            : formData?.duration_type == 3
                              ? "Weeks"
                              : formData?.duration_type == 4
                                ? "Months"
                                : ""}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalduretion(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>

                  <ErrorMessage
                    name="duration_type"
                    component="div"
                    className="error"
                  />
                  <ErrorMessage
                    name="duration"
                    component="div"
                    className="error"
                  />

                  {Array.isArray(formData?.milestones) && (
                    <>
                      <div className="project-section">
                        <div className="w-100">
                          <p className="d-flex justify-content-between align-items-center">Milestones   <span
                            className="btn"
                            onClick={() => {
                              setModalMils(true);
                            }}
                          >
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                              alt=""
                            />
                          </span></p>
                          {(Array.isArray(formData?.milestones) && formData?.milestones?.length > 0) ? (
                            <>
                              <MilestonesDisplay formData={formData} />
                            </>
                          ) :
                            <p className="d-flex">No milestone created</p>
                          }
                        </div>
                        {/* <span
                          className="btn"
                          onClick={() => {
                            setModalMils(true);
                          }}
                        >
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                            alt=""
                          />
                        </span> */}
                      </div>
                      <ErrorMessage
                        name="milestones"
                        component="div"
                        className="error"
                      />
                    </>
                  )}
                  <div className="project-section">
                    <div className="w-100">
                      <p>Attachments</p>
                      <div className="images image-row1 row">
                        {formData.files &&
                          Array.isArray(formData.files) &&
                          formData.files.map(
                            (item, index) =>
                              item.status != 3 && (
                                <DisplayFileProper item={item} />
                              )
                          )}
                      </div>
                    </div>
                    <span
                      onClick={() => {
                        setModalFile(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="files"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Expected deliverables</p>
                      <CustomReactQuillDescription
                        value={formData?.deliverables}
                      />
                    </div>
                    <span
                      onClick={() => {
                        setModaldeliverables(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="deliverables"
                    component="div"
                    className="error"
                  />

                  <div className="project-section">
                    <div>
                      <p>Preferred Language of Work Submission</p>
                      <h4>
                        {formData?.languageindex?.label ||
                          formData?.languageindex}
                      </h4>
                    </div>
                    <span
                      onClick={() => {
                        setModalLanguege(true);
                      }}
                    >
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </span>
                  </div>
                  <ErrorMessage
                    name="language_id"
                    component="div"
                    className="error"
                  />
                </div>
              </div>
              <Modal
                className="popupmodal"
                isOpen={modaltitle}
                toggle={() => setModaltitle((state) => !state)}
              >
                <ModalTitle
                  title={title}
                  setModaltitle={setModaltitle}
                  handleInputTitle={handleInputTitle}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={industryEditModal}
                toggle={() => setIndustryEditModal((state) => !state)}
              >
                <ModalIndustry
                  industry_index={industry_index}
                  formData={formData}
                  setFormData={setFormData}
                  setIndustryEditModal={setIndustryEditModal}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalcategory}
                toggle={() => setModalCategory((state) => !state)}
              >
                <ModelCategory
                  formData={formData}
                  setFormData={setFormData}
                  category={category}
                  setModalCategory={setModalCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalsubcategory}
                toggle={() => setModalSubCategory((state) => !state)}
              >
                <ModelSubCategory
                  subcategory={subcategory}
                  parentid={formData.category_id}
                  formData={formData}
                  setFormData={setFormData}
                  setModalSubCategory={setModalSubCategory}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaldescription}
                toggle={() => setModalDescription((state) => !state)}
              >
                <ModalDescription
                  setFormData={setFormData}
                  description={description}
                  setModalDescription={setModalDescription}
                  handleInputDescription={handleInputDescription}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalduretion}
                toggle={() => setModalduretion((state) => !state)}
              >
                <ModelDuretion
                  formData={formData}
                  setFormData={setFormData}
                  duration={duration}
                  setModalduretion={setModalduretion}
                  handleInputDuretion={handleInputDuretion}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalBudget}
                toggle={() => setModalBudget((state) => !state)}
              >
                <ModelBudget
                  price={price}
                  setModalBudget={setModalBudget}
                  handleInputBudget={handleInputBudget}
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalLanguage}
                toggle={() => setModalLanguege((state) => !state)}
              >
                <ModelLanguage
                  formData={formData}
                  setFormData={setFormData}
                  language_id={language_id}
                  setModalLanguege={setModalLanguege}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaldeliverables}
                toggle={() => setModaldeliverables((state) => !state)}
              >
                <ModelDeliverables
                  setFormData={setFormData}
                  deliverables={deliverables}
                  setModaldeliverables={setModaldeliverables}
                  handleInputExpecteddeliverables={
                    handleInputExpecteddeliverables
                  }
                  hitApi={hitApi}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalfile}
                toggle={() => setModalFile((state) => !state)}
              >
                <ModelFile
                  formData={formData}
                  setFormData={setFormData}
                  setModalFile={setModalFile}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modalSkills}
                toggle={() => setModalSkills((state) => !state)}
              >
                <ModelSkills
                  formData={formData}
                  setFormData={setFormData}
                  setModalSkills={setModalSkills}
                />
              </Modal>
              <Modal
                size="xl"
                className="popupmodal"
                isOpen={modalMils}
                toggle={() => setModalMils((state) => !state)}
              >
                <ModelMilestones
                  formData={formData}
                  setFormData={setFormData}
                  setModalMils={setModalMils}
                />
              </Modal>
              <Modal
                className="popupmodal"
                isOpen={modaltype}
                toggle={() => setModaltype((state) => !state)}
              >
                <ModelType
                  formData={formData}
                  setFormData={setFormData}
                  setModaltype={setModaltype}
                />
              </Modal>
            </div>
          </Form>
        )}
      </Formik>
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />
    </div>
  );
};

export default UpdateProject;

